export const isDevelopment = () => {
  return import.meta.env.DEV
}

export const isProduction = () => {
  return import.meta.env.PROD
}

export const isTest = () => {
  return import.meta.env.MODE === 'test'
}

/**
 * Récupère le mode actuel de l'environnement
 * @returns {string} 'development', 'production' ou 'test'
 */
export const getEnvironmentMode = () => {
  if (import.meta.env.DEV) return 'development'
  if (import.meta.env.PROD) return 'production'
  return 'test'
}

export const setTimeoutInDev = () => {
  if(isDevelopment()) {
    return new Promise(resolve => setTimeout(resolve, 1500))
  }
  return Promise.resolve()
}
